

























































































import {
  defineComponent, defineAsyncComponent, ref, onMounted, computed,
  onBeforeUnmount,
} from '@vue/composition-api';
import { getSuperMemberCardSummary } from '@/api/rights/index';
import {
  SuperMemberSceneEnum, SuperCardSummaryBackType, PayWayEnum,
  PackageBuyStatusEnum, SuperMemberSourceEnum, RightPackageTypeEnum, SuperCardStyleTypeEnum,
} from '@/api/rights/types';
import type { RightContractPopType } from '@/components/right-contract-pop/right-pop';
import { openThirdPage } from '@/api/native/utils';
import { RightsPayInstance } from '@/shared/right-utils/rightsPay';
import { RightHelper } from '@/shared/right-router-helper';
import { goBindBankCard } from '@/shared/right-utils/cardbind';
import {
  RIGHTS_ENTER, RIGHTS_AGREEMENT, RIGHTS_AGREEMENT_CHECK, RIGHTS_DETAIL_DETAIL_OPEN,
} from '@/shared/right-utils/ubtRights';
import { ubtSetupPageButton, ubtSetupModuleExpose, getSetupBusinessInfo } from '@/shared/utils/ubt/ubt-setup';
import { ForceReadService } from '@/widgets/right-contract';
import { ubtSendError } from '@/shared/utils/ubt';
import { ContractReadStatusEnum } from '@/widgets/right-contract/enum';

/** 优惠卷里的成功遮罩层 */
const SuccessOverlayCoupon = () => import(
  /* webpackChunkName: "async-success-overlay-coupon" */ '@/widgets/rights/SuccessOverlay.vue'
);

/** 协议组件 */
const ContactPopCoupon = () => import(
  /* webpackChunkName: "async-right-contact-pop-coupon" */ '@/components/right-contract-pop'
);

const SuccessOverlay = defineAsyncComponent(SuccessOverlayCoupon);
const ContactPop = defineAsyncComponent(ContactPopCoupon);

export default defineComponent({
  components: {
    ContactPop,
    SuccessOverlay,
  },
  setup() {
    /** 接口返回时概要数据 */
    const superMemberCardSummaryList = ref<SuperCardSummaryBackType>({});

    /** 是否勾选 */
    const isChecked = ref<boolean>(false);

    /** 协议弹窗ref */
    const rightContractPop = ref<RightContractPopType>();

    /** 是否展示提示气泡 */
    const showBuyConfirm = ref<boolean>(false);

    /** 是否展示成功浮层 */
    const showSuccOverlay = ref<boolean>(false);

    /** 订单id */
    const orderId = ref<string>('');

    const {
      readStatus, handleForceRead, destroyInstance,
    } = ForceReadService({
      packageType: RightPackageTypeEnum.SUPER_MEMBER_CARD,
      forceReadFromScene: SuperMemberSourceEnum.MY_COUPON,
    });

    /** 统一埋点参数上报 */
    const tqParams = computed(() => {
      const {
        packageId, packageType, supplierCode, sellPrice, packageName,
      } = superMemberCardSummaryList.value || {};
      return {
        packageId,
        packageType,
        packageName,
        supplierCode,
        sellPrice,
        from: SuperMemberSourceEnum.MY_COUPON,
      };
    });

    /** 是否样式A(对照组) 实验由后端接入 */
    const isStyleA = computed(() => superMemberCardSummaryList.value
      && superMemberCardSummaryList.value.extraInfo
      && superMemberCardSummaryList.value.extraInfo.style === SuperCardStyleTypeEnum.STYLE_A);

    /** 获取超级会员概要数据 */
    const superMemberCardSummary = async (): Promise<void> => {
      try {
        superMemberCardSummaryList.value = await getSuperMemberCardSummary({
          sceneType: SuperMemberSceneEnum.COUPON_LIST,
        });
      } catch {
        superMemberCardSummaryList.value = {};
      }
    };

    /** 变更勾选状态 */
    const changeChecked = async () => {
      isChecked.value = !isChecked.value;
      /** 勾选状态为选中时上报 */
      if (isChecked.value) {
        ubtSetupPageButton(RIGHTS_AGREEMENT_CHECK, {
          ...tqParams.value,
          checkStatus: isChecked.value,
        });

        const { contractInfo } = superMemberCardSummaryList.value;

        isChecked.value = await handleForceRead({
          packageType: RightPackageTypeEnum.SUPER_MEMBER_CARD,
          forceReadFromScene: SuperMemberSourceEnum.MY_COUPON,
          contractScene: contractInfo?.scene || '',
          tqParams: tqParams.value,
        });
      }
    };

    /** 打开协议弹窗 */
    const openContract = async () => {
      /** 点击协议弹窗曝光 */
      ubtSetupPageButton(RIGHTS_AGREEMENT, tqParams.value);
      const { contractInfo } = superMemberCardSummaryList.value;
      if (contractInfo) {
        const handleRes = await handleForceRead({
          packageType: RightPackageTypeEnum.SUPER_MEMBER_CARD,
          forceReadFromScene: SuperMemberSourceEnum.MY_COUPON,
          tqParams: tqParams.value,
          contractScene: contractInfo?.scene || '',
          preview: true,
        });
        if (handleRes) {
          isChecked.value = handleRes;
        }
      }
    };

    /** 去支付 */
    const goPay = async () => {
      // 这里只处理打点，不做任何接口层面的二次校验
      if (readStatus === ContractReadStatusEnum.NEED_READ_NOT_READ) {
        ubtSendError({
          name: 'right_force_read',
          message: 'needReadContract but not read',
          stack: SuperMemberSourceEnum.MY_COUPON,
        });
      }

      const {
        isSelectPayWay, packageId, packageType, payWay, sellPrice, contractInfo,
      } = superMemberCardSummaryList.value;

      if (!isSelectPayWay) {
        ubtSetupPageButton(RIGHTS_DETAIL_DETAIL_OPEN, tqParams.value);
      }

      if (!isSelectPayWay && !isChecked.value) {
        showBuyConfirm.value = true;
      } else {
        const payRes = await RightsPayInstance.H5pay({
          packageType: RightPackageTypeEnum.SUPER_MEMBER_CARD,
          packageId,
          needChoosePayWay: isSelectPayWay,
          contractInfo,
          payAmount: sellPrice,
          payWay,
          from: SuperMemberSourceEnum.MY_COUPON,
          businessInfo: getSetupBusinessInfo(tqParams.value),
          goBindBankCard: ((options: { scene: string; bindCardApplySessionId: string; }) => {
            const {
              scene, bindCardApplySessionId,
            } = options;
            if (packageId) {
              goBindBankCard(
                SuperMemberSourceEnum.MY_COUPON,
                scene,
                packageId,
                bindCardApplySessionId,
                RightPackageTypeEnum.SUPER_MEMBER_CARD,
              );
            }
          }),
        });
        /** 成功回调 */
        if (payRes && payRes.status === 1) {
          orderId.value = payRes.orderId;
          showSuccOverlay.value = true;
        }
      }
    };

    /** 去往会员详情页 */
    const goDetail = () => {
      const url = RightHelper.dispatchRouterByBuyStatus(
        RightPackageTypeEnum.SUPER_MEMBER_CARD,
        SuperMemberSourceEnum.MY_COUPON,
        PackageBuyStatusEnum.NOT_BUY,
      );

      openThirdPage(url);

      /** 监听回退事件 */
      document.addEventListener('visibilitychange', () => {
        /** 刷新数据 emit */
        if (document.visibilityState === 'visible') {
          superMemberCardSummary();
        }
      });
    };

    /** 更新遮罩层值 */
    const updateIsSuccOverlay = (value: boolean) => {
      showSuccOverlay.value = value;
    };

    /** 关闭开通成功蒙层回调 */
    const closeOverlay = () => {
      superMemberCardSummary();
    };

    const payWayText = computed(() => {
      if (superMemberCardSummaryList.value
        && superMemberCardSummaryList.value.payWay === PayWayEnum.Card) {
        return '银行卡';
      }
      return '支付宝';
    });

    onMounted(async () => {
      await superMemberCardSummary();
      if (superMemberCardSummaryList.value) {
        /** 接口返回数据有数据时曝光 */
        ubtSetupModuleExpose(RIGHTS_ENTER, tqParams.value);
      }
    });

    onBeforeUnmount(() => {
      document.removeEventListener('visibilitychange', () => {
        superMemberCardSummary();
      });
      destroyInstance();
    });

    return {
      superMemberCardSummaryList,
      isChecked,
      showBuyConfirm,
      showSuccOverlay,
      rightContractPop,
      PackageBuyStatusEnum,
      RightPackageTypeEnum,
      SuperCardStyleTypeEnum,
      payWayText,
      orderId,
      isStyleA,

      changeChecked,
      openContract,
      goPay,
      goDetail,
      closeOverlay,
      updateIsSuccOverlay,
    };
  },
});
